import React from 'react'
import { Redirect } from 'react-router-dom'

const home = (props) => (
  <Redirect to="/login" />
)

export default home



// WEBPACK FOOTER //
// ./src/routes/home/Home.js